import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

// import Slider from './slider';

class ConNav extends React.PureComponent {
    static propTypes = {
        conNavHeader: PropTypes.object,
    };

    render() {
        const { conNavHeader } = this.props;

        return (
            <div className={styles.conNav}>
                <a href="//www.ifeng.com/">凤凰网</a>
                &gt; {conNavHeader.navCenter} &gt;
                <a href="//www.ifeng.com/corp/about/">{conNavHeader.navRight}</a>
            </div>
        );
    }
}

export default ConNav;
